<template>
  <div class="ValidIdentityManual">
    <div class="container">
      <!-- Content here -->
      <br />

      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="#">3天內為您手動驗證身份</a>
      </nav>

      <br />
      <div class="card">
        <div class="card-body">
          <h5>
            我們將會在3天內為您手動驗證身份，驗證成功將會主動推播您!
            有任何問題都可以跟我們客服反應!
          </h5>
          <br />
          <h5>我們可以回到聊天室繼續操作了!</h5>
          <hr />
          <h5>申請過委託單，可以往上滑再點一次付款即可付款!</h5>

          <!-- <router-link to="/store">
            <button type="button" class="btn btn-primary btn-block">
              回到商品列
            </button>
          </router-link>-->
        </div>
      </div>
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<style type="text/css"></style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'ValidIdentityManual',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: '',
      isLoading: false,
      userId: '',
      userImage: '',
      userName: '',
    }
  },
  watch: {},
  methods: {},
  mounted() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  },
}
</script>
